import axios from 'axios'
import config from '../config'
import {
    Message
} from 'element-ui';
import {
    startLoading,
    endLoading
} from '../processing'
import {
    handleError
} from '../index'
import cookie from 'js-cookie'
import quit from '@/common/quit.js'
axios.defaults.baseURL = config.baseURL

function authHeader() {
    return {
        'x-auth-token': cookie.get('token')
    }
}

let base64 = ''


export default {
    regionOperationStation: async (data, type) => {
        startLoading();
        try {
            if (type === 'remove') {
                await axios.delete(`/station/${data.stationUUID}`, {
                    headers: authHeader()
                })
            } else if (type === 'resolve') {
                await axios.post('/station/agent/unbind', data, {
                    headers: authHeader()
                })
            } else {
                await axios.put('/region/station/review', data, {
                    headers: authHeader()
                })
            }

            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    regionGetAgentListforAddStation: async (params) => {
        startLoading();
        try {
            const result = await axios.get(`/region/agent`, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    regionAddStation: async (data) => {
        startLoading();
        try {
            await axios.post('/region/station', data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    regionEditStation: async (data) => {
        startLoading();
        try {
            await axios.put('/region/station', data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    regionGetStationAuthorizeList: async (params) => {
        startLoading();
        try {
            params.sort = 'createdAt,DESC'
            params.size = 20
            const result = await axios.get(`/region/station/authorize`, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    regionAuthStation: async (data) => {
        startLoading();
        try {
            await axios.put('/region/station/authorize', data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getAgentList: async (params, type) => {
        startLoading();
        try {
            const result = await axios.get(`/${type}/agent`, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    distributeAgent: async(params) => {
        startLoading();
        try {
            const result = await axios.post(`/distribution/agent`, params, {
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    distributeStation: async(params) => {
        startLoading();
        try {
            const result = await axios.post(`/distribution/station`, params, {
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    updatePatientShowFlag: async(id, enabled) => {
        startLoading();
        try {
            await axios.put(`/station/${id}/patientShow`, null, {
                params: {enabled: enabled}, 
                headers: authHeader()
            })
            endLoading()
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    updatePresellFlag: async(id, enabled) => {
        startLoading();
        try {
            await axios.put(`/station/${id}/presellFlag`, null, {
                params: {enabled: enabled}, 
                headers: authHeader()
            })
            endLoading()
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    regionUpdateAgentInfo: async (operation, data) => {
        startLoading()
        try {
            let result
            if (operation === 'deleteAccount') {
                result = await axios.delete('/region/agent', {
                    params: {
                        agentId: data
                    },
                    headers: authHeader()
                })
            } else if (operation === 'buyGoods') {
                result = await axios.post('/region/agent/treatment/pay', data, {
                    headers: authHeader()
                })
            } else if (operation === 'rejectGoods') {
                result = await axios.post('/region/agent/treatment/refund', data, {
                    headers: authHeader()
                })
            } else {
                result = await axios.put('/region/agent', data, {
                    headers: authHeader()
                })
            }

            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getAgentAcountListByAgentId: async (agentId, param) => {
        startLoading();
        try {
            let params = param || {}
            params.sort = 'createdAt,DESC'
            params.size = 20
            let result = await axios.get(`/region/agent/${agentId}/subordinate`, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getAgentPurchaseHistoryByAgentId: async (agentId) => {
        startLoading();
        try {
            let params = {}
            params.sort = 'createdAt,DESC'
            params.size = 20
            let result = await axios.get(`/region/agent/${agentId}/subordinate`, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getAgentAchievementHistoryByAgentId: async (agentId) => {
        startLoading();
        try {
            let params = {}
            // params.sort = 'createdAt,DESC'
            // params.size = 20
            let result = await axios.get(`/agent/${agentId}/achievement`, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    regionAddAgentYearTarget: async (data) => {
        startLoading();
        try {
            await axios.post('/region/agent/achievement', data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    regionUpdateAgentTarget: async (AgentId, data, remark) => {
        startLoading();
        try {
            let url
            if (remark) {
                url = '/agent/achievement/remark'
            } else {
                url = `/agent/${AgentId}/achievement`
            }
            await axios.put(url, data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getAgentOrgnaizationsByAgentId: async (agentId, param) => {
        startLoading();
        try {
            let params = param || {}
            params.sort = 'createdAt,DESC'
            params.size = 20
            let result = await axios.get(`/agent/${agentId}/station`, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getAgentManageRangeByAgentId: async (agentId, provinceName) => {
        startLoading();
        try {
            let params = {}
            // params.sort = 'createdAt,DESC'
            // params.size = 20
            if (provinceName) {
                params.districtName = provinceName
            }
            let result = await axios.get(`/agent/${agentId}/district`, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    findAgentPurchase: async(param) => {
        startLoading();
        try {
            let params = param || {}
            params.sort = 'createdAt,DESC'
            params.size = 20
            let result = await axios.get(`/purchase/histories`, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    exportAgentPurchase: async(param) => {
        startLoading();
        try {
            let params = param || {}
            params.sort = 'createdAt,DESC'
            params.size = 10000
            const result = await axios.get(`/export/purchase/histories`, {
                params: params,
                responseType: "blob",
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    getAgentPurchaseHistorByAgentId: async (agentId, param) => {
        startLoading();
        try {
            let params = param || {}
            params.sort = 'createdAt,DESC'
            params.size = 20
            let result = await axios.get(`/region/agent/${agentId}/purchase/history`, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    setAgentPurchasePaymentById: async (historyId) => {
        startLoading();
        try {
            let data = {
                historyId,
            }
            // params.sort = 'createdAt,DESC'
            // params.size = 20
            let result = await axios.put(`/region/agent/purchase/history/payment`, data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    regionUpdateRedfund: async (data) => {
        startLoading();
        try {
            let result = await axios.put(`/patient/treatment/refund/review`, data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    findAgentByGrade: async(params) => {
        startLoading();
        try {
            let result = await axios.get(`/region/agent/find`, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    regionUpdateAgentGrade: async (data) => {
        startLoading();
        try {
            let result = await axios.put(`/region/agent/grade`, data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    findSalesPromotions: async(params) => {
        startLoading();
        try {
            console.log(params);
            let result = await axios.get(`/sales/promotion`, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return result.data;
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    saveSalesPromotions: async(data) => {
        startLoading();
        try {
            await axios.post('/sales/promotion', data, {
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    },
    updateSalesPromotionAuditFlag: async(params) => {
        startLoading();
        try {
            console.log(params);
            await axios.put(`/sales/promotion`, null, {
                params: params,
                headers: authHeader()
            })
            endLoading()
            return 'success'
        } catch (error) {
            endLoading()
            handleError(error)
        }
    }
}


// WEBPACK FOOTER //
// ./src/http/componentsAPI/management.js